import React from 'react';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';

// Components
// import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';
import Button from 'components/_shared/Button/Button';

// SVGs

// Images
import Blanca from 'images/blanca.png';
import Emely from 'images/emely.png';
import John from 'images/john.png';
import Alfredo from 'images/alfredo.png';
import map from 'images/map_background_2.png';
import elevate from 'images/elevate_logo_v2.png';

// Constants
import { students } from 'constants/constants';

// Services
import { homeLeaderLines, addArc } from 'services/lineCreators';

// Redux Actions
import { setSearch } from 'store/modules/db/search/searchReducer';

// Styles
import './Home.css';

const studentImgs = {
  blanca: Blanca,
  emely: Emely,
  john: John,
  alfredo: Alfredo
}

export class Home extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    readMores: [],
    videoLoopIdx: 0,
    pathways: null,
    lines: []
  }

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {

    // setup youtube player
    if (window['YT']) {
      window['YT'] = undefined;
    }
    this.ytInit();

    // setup leader lines
    if (navigator.userAgent !== 'ReactSnap') {
      window.addEventListener("resize", this.updateDimensions);
      this.cleanMount()
    }
    // this.mountLines();

    // refresh logic
    if (window.performance.navigation.type === 1) {
      // console.info( "This page is reloaded" );

      // change pathways border radius
      // if (this.state.pathways) {
      //   this.setPathways();
      // }
    } else {
      // console.info( "This page is not reloaded");
    }
  }

  componentDidUpdate() {
    // change pathways border radius
    if (this.state.pathways && !this.state.lines.length && navigator.userAgent !== 'ReactSnap') {
      this.setPathways();
    }
  }

  // componentWillMount() {
  //   this.updateDimensions();
  // }

  componentWillUnmount() {
    if (navigator.userAgent !== 'ReactSnap') {
      this.clearPathways();
      window.removeEventListener("resize", this.updateDimensions);
    }
  }

  clearPathways = () => {
    let { pathways } = this.state;
    if (pathways) {
      Object.keys(pathways).forEach(line => {
        pathways[line].remove();
      })
    }
  }

  mountLines = () => {
    let refs = {
      blanca: this.blancaRef,
      emely: this.emelyRef,
      john: this.johnRef,
      alfredo: this.alfredoRef,
      homeRef: this.homeRef,
      reportBtnRef: this.reportBtnRef,
      exploreBtnRef: this.exploreBtnRef,
      pathwaysBtnRef: this.pathwaysBtnRef,
      addmeBtnRef: this.addmeBtnRef
    }

    this.setState({
      pathways: homeLeaderLines(window.innerWidth, refs)
    });
  }

  cleanMount = () => {
    this.clearPathways();
    this.setState({pathways: null}, () => {
      this.mountLines()
    })
  }

  updateDimensions = () => {
    this.cleanMount();
    this.setPathways();
    // this.forceUpdate()
  }
  // Event handlers
  // ------------------------------------------------------------------------ //
  directoryNav = () => {
    this.props.dispatch(push('/directory'))
  }

  pathwaysNav = () => {
    this.props.dispatch(push('/pathways'))
  }

  reportNav = () => {
    this.props.dispatch(push('/report'))
  }

  addNav = () => {
    this.props.dispatch(push('/add-org'))
  }

  searchAndNav = (e, val) => {
    if (e) e.preventDefault()
    this.props.dispatch(setSearch({ search: val }));

    if (this.props.location.pathname.indexOf('directory') < 0) {
      this.directoryNav()
    }
  }

  handleReadMore = student => {
    let { readMores } = this.state;
    if (readMores.indexOf(student) > -1) {
      readMores = readMores.filter(person => student !== person)
    } else {
      readMores = readMores.concat(student);
    }
    this.setState({ readMores });
  }

  // Class methods
  // ------------------------------------------------------------------------ //
  setPathways = () => {
    let lines = Array.from(document.getElementsByClassName(`leader-line-line-path`))
      .map(line => {
        try {
          line.setAttribute('d', addArc(line.getAttribute('d'), 50));
        } catch (e) {
        }
        return line;
      }
      ).filter(path => path)

    this.setState({lines})
  }

  ytInit = () => {
    let tag = document.createElement('script');
    tag.id = "ytVideo";
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window['onYouTubeIframeAPIReady'] = (e) => {
      this.YT = window['YT'];
      this.player = new window['YT'].Player('ytPlayer', {
        events: {
          'onStateChange': this.onPlayerStateChange,
          'onReady': this.onReady,
        }
      });
    };
  }

  assignRefFunc = refEle => {
    const self = this;
    return ref => {
      self[refEle] = ref;
    }
  }

  // Render methods
  // ------------------------------------------------------------------------ //

  renderStudents = columnNumber => {
    const indexes = columnNumber === 1 ? [0,1] : [2,3];
    return Object.keys(students).map((student, id) => {
      if (indexes.indexOf(id) < 0) {
        return null;
      }
      let more = this.state.readMores.indexOf(student) > -1;
      return (
        <React.Fragment key={student}>
          {columnNumber === 2 && id === 2 && (<article key={`${student}_blurb_2`} className="home__student-blurbs">
            <h2 className="home__detail-headline">Meet a few of the artworxLA students who have found creative interships through Elevate's pathways.</h2>
            <Button
              refFunc={this.assignRefFunc('pathwaysBtnRef')}
              className="home__button pathways-btn"
              onClick={this.pathwaysNav}
              value="See pathways"
            />
          </article>)}

          <article
            key={student}
            className="home__student-container">
            <div className="home__student-details">
              <div
                ref={ref => this[`${student}Ref`] = ref}
                className="home__student-photo">
                <LazyLoad height={'100%'}>
                  <img src={studentImgs[student]} alt={student}/>
                </LazyLoad>
              </div>
              <div className="home__student-title">
                <p><strong>{students[student].name}</strong></p>
                <a target="_blank" href={students[student].title.site} className="home--primary-color" rel="noopener noreferrer">{ students[student].title.placement }</a>
              </div>

              <div className={`
                home__student-detail
                `}>
                <div className={`
                  home__student-info-container
                  ${more ? 'home__student--expand' : 'home__student--collapsed'}
                `}>
                  <div className="home__student-info">
                    <p dangerouslySetInnerHTML={{ __html: students[student].details }}></p>
                  </div>
                  <div
                    className={`
                      home__student-read
                      home--primary-color
                    `}
                    onClick={e => this.handleReadMore(student)} >
                    <a href="#/">read {`${more ? 'less' : 'more'}`}</a>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {columnNumber === 1 && id === 1 && (<article key={`${student}_blurb_1`} className="home__student-blurbs">
            <h2 className="home__detail-headline">If you're a creative opportunity provider or supporting organization, learn how you can be a part of Elevate. We're all in this together.</h2>
            <Button
              refFunc={this.assignRefFunc('addmeBtnRef')}
              className="home__button addme-btn"
              onClick={this.addNav}
              value="Join the directory"
            />
          </article>)}
        </React.Fragment>

      )})
  }


  onPlayerStateChange = e => {
    // console.log('YT onPlayerStateChange', e, window['YT'].PlayerState)
    // if (e.data === window['YT'].PlayerState.ENDED) {
    //   this.setState({
    //     videoLoopIdx: !this.state.videoLoopIdx ? 1 : 0
    //   }, () => {
    //     e.target.loadVideoById({
    //       videoId: youTubeVideoId,
    //       startSeconds: youTubeStart[this.state.videoLoopIdx],
    //       endSeconds: youTubeEnd[this.state.videoLoopIdx]
    //     })
    //   })
    // }
  }

  onReady = e => {
    // access to player in all event handlers via event.target
    // console.log('YT onReady')
    e.target.playVideo();
  }

  render() {
    return (
      <div className={`
        home
        ${this.state.readMores.indexOf('alfredo') > -1 ? 'home--expand' : ''}
        `}>
        <section ref={ ref => this.homeRef = ref } className="home__hero">
          <LazyLoad height={'100%'}>
            <div className="home__hero-videoWrapper">
              <iframe id="ytPlayer" title="elevate hero" width="100%" height="100%" src={ `https://www.youtube.com/embed/mUWiJuo9Sj4?controls=0&enablejsapi=1&start=101&end=163&loop=1&modestbranding=1&rel=0&mute=1&playlist=mUWiJuo9Sj4&autohide=1&autoplay=1&origin=https://elevate.artworxla.org` } allow="autoplay; encrypted-media" frameBorder="0"></iframe>
            </div>
          </LazyLoad>
          <div className="home__hero-banner">
            <div className="home__hero-banner-container">
              <img className="home__hero-logo" src={elevate} alt="elevate"/>
              <div className="home__hero-subtitle">
                <h3>Creative Career Pathways for LA's Opportunity Youth</h3>
              </div>
            </div>
          </div>
        </section>

        <section className="home__section-report">
          <article>
            <h2 className="home__detail-headline">Creativity is a critical part of the Los Angeles economy, comprising 1 in 7 jobs. In spite of so many jobs, gaining access to them is more difficult than you might think.</h2>
          </article>
          <article className="home__creativity-details">
            <p className="home__detail-content"><strong>Elevate</strong> helps Opportunity Youth - young people who struggle to connect to education and creative employment - by identifying the multi-sector efforts that pave <Link to="/pathways" className="home--primary-color">pathways to learning and work opportunities</Link>.</p>
            {/* TODO: is this second span a link to report page or report? */}
            <Button
              refFunc={ this.assignRefFunc('reportBtnRef') }
              className="home__button"
              onClick={this.reportNav}
              value="Read Report"
            />
          </article>
        </section>

        <section className="home__section-explore">
          <div className="home__section__img-overlay">
            <LazyLoad height={'100%'}>
              <img src={map} alt="explore"/>
            </LazyLoad>
          </div>
          <article 
            ref={ ref => this.exploreArticleRef = ref }
            className="home__actionable-details">
            <h2 className="home__detail-headline">Elevate is a network and a tool, making it easier for creative opportunity providers to engage LA's most vulnerable youth.</h2>
            <div className="home__detail-container">
              <p className="home__detail-content"><strong>Elevate's</strong> directory network shows what services are available and how to connect with them, fostering a more cohesive and efficient support system for LA's Opportunity Youth.</p>
              <Button
                refFunc={ this.assignRefFunc('exploreBtnRef') }
                className="home__button"
                onClick={this.directoryNav}
                value="Explore directory"
              />
            </div>
          </article>
        </section>

        <section className="home__section-students">
          <div className="home__students-column">
            { this.renderStudents(1) }
          </div>

          <div className="home__students-column">
            { this.renderStudents(2) }
          </div>
        </section>

      </div>
    );
  }
}

export default connect(null)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/Home.js